<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>{{ $t('experiences.edit') }}: {{ experienceName }}</h4>
          </div>
          <div class="card-body">
            <ExperiencesForm 
              :experienceId="experienceId" 
              @form-submitted="formSubmitted" 
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExperiencesForm from './ExperiencesForm.vue';
import router from '@/router';

export default {
  components: {
    ExperiencesForm
  },
  computed: {
    experienceId() {
      return this.$route.query.id;
    },
    experienceName() {
      return this.$route.params.name || '';
    }
  },
  methods: {
    formSubmitted() {
      router.push({ name: 'Experiences' });
    }
  }
}
</script>

